<!-- 页面内容 -->
<!--新闻详情页-->
<template>
    <!-- container -->
    <div class='content'>
        <div class="container nav">
            <span style="color: #8FA2B2;" @click="goNews">News</span> > Details
        </div>
        <div class="container contD">
            <div class="cont">
                <div class="contV">
                    <div class="topA">
                        <div class="topA1">
                            <div class="t1">{{ info.heading }}</div>
                            <div class="t2">{{ info.createTime }}</div>
                            <div class="t3" v-html="info.content"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="contA">
                <div class="contV1">
                    <div class="v1">More News</div>
                    <div class="MoreList" v-for="(item, index) in List" :key="index" @click="goChange(item.newsId)">
                        <div class="line"></div>
                        <div class="MoreListV">
                            <img class="Img" :src="item.thumbnail" alt="" />
                            <div class="Td">
                                <div class="T1">{{ item.heading }}</div>
                                <div class="T2">{{ item.subtitle }}</div>
                                <div class="T2">{{ item.text }}</div>
                                <div class="T3">{{ item.createTime }}</div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            ids: '',
            info: {},
            List: [],
            Text: ''
        }
    },
    mounted() {
        this.ids = this.$route.query.ids;
        // this.detialApi();
        this.listApi(this.ids);
    },
    methods: {
        goNews() {
            this.$router.push({
                path: "news"
            })
        },
        goChange(e) {
            this.ids = e;
            this.listApi();
            // this.detialApi(this.ids);
            // console.warn(e, "eee")
        },
        // 新闻
        // async detialApi(id) {
        //     try {
        //         const res = await this.$get('system/news/list', {
        //             newsId: id
        //         });
        //         console.warn(res.rows, "rrrrr")
        //         this.info = res.rows[0] || {};
        //     } catch (error) {
        //     }
        // },
        async listApi() {
            try {
                const res = await this.$get('system/news/list');
                res.rows.forEach(v => {
                    if (v.newsId == this.ids) {
                        this.info = v
                    }
                });
                this.List = res.rows || [];
            } catch (error) {
            }
        },
        goForm() {
            this.$router.push({
                path: "customizationFrom"
            })
        }
    },
}
</script>

<style lang='scss' scoped>
@import './newsDetial.scss';
</style>